import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ffdbc3d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-selector" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Wonderkind Profiles", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Add New Profile")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_default_button = _resolveComponent("default-button")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", null, [
      _createElementVNode("section", _hoisted_1, [
        _createVNode(_component_router_link, { to: "/profiles" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_default_button, { onActivate: _ctx.openProfileModal }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onActivate"])
    ])
  ]))
}